<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">CP游戏记录</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="app-container">
        <div class="header-id" style="margin-bottom: 20px">
          <div style="margin-bottom: 40px">
            <FilterCommon :model="model" :isAdd="true" @add="add" @search="search" :isReset="true" @reset="reset"></FilterCommon>
            <el-table border v-loading="listLoading" :data="tableData" style="width: 100%" min-height="200" max-height="1000">
              <el-table-column prop="game_name" label="游戏名称" width="150" />
              <el-table-column prop="platform_text" label="平台" width="100" />
              <el-table-column prop="version_type" label="版本类型" width="100" />
              <el-table-column prop="link" label="CP运营后台链接" width="200" />
              <el-table-column prop="created_at" label="上传时间" width="150" />
              <el-table-column prop="admin_name" label="上传人" width="100" />
              <el-table-column prop="remark" label="备注" width="150" />
              <el-table-column label="运营账号密码" width="200">
                <template slot-scope="scope">
                  <p>{{ `运营账号：${scope.row.manager_account}` }}</p>
                  <p>{{ `运营密码：${scope.row.manager_password}` }}</p>
                </template>
              </el-table-column>
              <el-table-column label="客服账号密码" width="200">
                <template slot-scope="scope">
                  <p>{{ `客服账号：${scope.row.service_account}` }}</p>
                  <p>{{ `客服密码：${scope.row.service_password}` }}</p>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="220">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
                  <el-button size="mini" type="primary" @click="remark(scope.row)">备注</el-button>
                  <el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
                  <el-button size="mini" type="primary" @click="history(scope.row)">历史操作记录</el-button>
                </template>
              </el-table-column>
            </el-table>
            <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
            <el-dialog title="删除" center width="40%" :visible.sync="deleteShow">
              <p style="text-align: center;">确认删除吗？</p>
              <div slot="footer" class="dialog-footer">
                <el-button @click="delCancel">取 消</el-button>
                <el-button type="primary" @click="delSure">确 定</el-button>
              </div>
            </el-dialog>
            <!-- 添加弹窗 -->
            <Dialog ref="dialog" @submitForm="dialogSure" @closeDialog="closeDialog" :dialogTitle="dialogTitle" :dialogVisible="dialogVisible" :dialogModel="dialogModel" dialogWidth="700px"></Dialog>
            <!-- 备注弹窗 -->
            <Dialog ref="remarkDialog" @submitForm="remarkSure" @closeDialog="closeRemark" :dialogTitle="'备注'" :dialogVisible="remarkVisible" :dialogModel="remarkModel" dialogWidth="700px"></Dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilterCommon from '../../common/Filter';
import Dialog from '../../common/Dialog';
import Pagination from '@/components/pagination/index';
import { cpGameAdminSelect, cpGameAdmin, cpGameAdminEditInfo, cpGameAdminEdit, cpGameAdminAdd, cpGameAdminDel, saveCpGameAdminRemark } from '@/api/dpartmentSmmary.js';

export default {
  components: {
    FilterCommon,
    Pagination,
    Dialog,
  },
  data() {
    return {
      listLoading: false,
      tableData: [],
      total: 0,
      listQuery: {
        game_id_array: [],
        version_type: '',
        page: 1,
        limit: 10,
      },
      dialogModel: [
        {
          type: 'el-select',
          label: '游戏',
          prop: 'game_id',
          options: [],
        },
        {
          type: 'el-select',
          label: '平台',
          prop: 'platform',
          options: [
            { label: '安卓', value: 1 },
            { label: 'IOS', value: 2 },
            { label: '通用', value: 3 },
          ],
        },
        {
          type: 'el-input',
          label: '版本类型',
          prop: 'version_type',
        },
        {
          type: 'el-input',
          label: 'CP后台链接',
          prop: 'link',
        },
        {
          type: 'el-input',
          label: '运营账号',
          prop: 'manager_account',
        },
        {
          type: 'el-input',
          label: '运营密码',
          prop: 'manager_password',
        },
        {
          type: 'el-input',
          label: '客服账号',
          prop: 'service_account',
        },
        {
          type: 'el-input',
          label: '客服密码',
          prop: 'service_password',
        },
        {
          type: 'el-input',
          label: '备注',
          prop: 'remark',
        },
      ],
      dialogVisible: false,
      dialogTitle: '新增',
      model: [
        {
          type: 'select',
          label: '游戏筛选',
          key: 'game_id_array',
          placeholder: '请选择游戏筛选',
          isMultiple: true,
          span: 4,
          options: [],
        },
        {
          type: 'input',
          label: '版本类型',
          key: 'version_type',
          span: 4,
        },
      ],
      remarkVisible: false,
      remarkModel: [
        {
          type: 'el-input',
          label: '备注',
          prop: 'remark',
        },
      ],
      deleteShow: false,
      deleteId: 0,
    };
  },
  created() {
    this.getList(this.listQuery);
    this.getCpGameAdminSelect();
  },
  methods: {
    // 获取列表数据
    async getList(query) {
      this.listLoading = true;
      const { data } = await cpGameAdmin(query);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.tableData = data.data.data;
      this.total = data.data.total;
      this.listLoading = false;
    },
    // 获取下拉框数据
    async getCpGameAdminSelect() {
      const { data } = await cpGameAdminSelect();
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      const { game } = data.data;
      const res = game.map((m) => {
        return { label: m.name, value: m.id };
      });
      this.model[0].options = res;
      this.dialogModel[0].options = res;
    },
    // 搜索
    search(data) {
      const { game_id_array, version_type } = data;
      this.listQuery.game_id_array = game_id_array;
      this.listQuery.version_type = version_type;
      this.getList(this.listQuery);
    },
    // 重置
    reset() {
      this.listQuery = {
        game_id_array: [],
        version_type: '',
        page: 1,
        limit: 10,
      };
    },
    // 新增
    add() {
      this.dialogVisible = true;
      this.dialogTitle = '新增';
      this.$refs.dialog.resetForm();
    },
    // 编辑
    async edit(row) {
      const { data } = await cpGameAdminEditInfo(row.id);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.dialogTitle = '编辑';
      this.dialogVisible = true;
      this.$refs.dialog.resetForm();
      this.$refs.dialog.editForm(data.data);
    },
    // 点击确定
    async dialogSure(form) {
      const { data } = this.dialogTitle === '新增' ? await cpGameAdminAdd(form) : await cpGameAdminEdit(form);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('操作成功');
      this.closeDialog();
      this.getList(this.listQuery);
    },
    // 点击关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
      this.$refs.dialog.resetForm();
    },
    // 关闭备注弹窗
    closeRemark() {
      this.remarkVisible = false;
      this.$refs.remarkDialog.resetForm();
    },
    // 备注
    async remark(row) {
      const { data } = await cpGameAdminEditInfo(row.id);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.remarkVisible = true;
      this.$refs.remarkDialog.resetForm();
      this.$refs.remarkDialog.editForm(data.data);
    },
    // 点击修改备注
    async remarkSure(form) {
      const { data } = await saveCpGameAdminRemark(form);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('修改成功');
      this.closeRemark();
      this.getList(this.listQuery);
    },
    // 删除
    async del(row) {
      this.deleteShow = true;
      this.deleteId = row.id;
    },
    // 取消删除
    delCancel() {
      this.deleteId = 0;
      this.deleteShow = false;
    },
    // 删除确定
    async delSure() {
      const { data } = await cpGameAdminDel(this.deleteId);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('删除成功');
      this.delCancel();
      this.getList(this.listQuery);
    },
    // 历史操作记录
    history(row) {
      this.$router.push({ name: 'history', params: { id: row.id } });
    },
  },
};
</script>

<style>
</style>